import { cn } from "@/lib/utils"

interface PanelProps {
  children: React.ReactNode
  className?: string
}

function PanelCard(props: PanelProps) {
  return (
    <div className={cn("flex h-[50px] items-center gap-1 rounded-xl bg-background px-2 shadow-panel", props.className)}>{props.children}</div>
  )
}

export default PanelCard
